// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__s7xhq","head":"ProcedureTableInfo_head__2nn2-"};